/* ==========================================================================
   Kuba PDP · caixa de compra (seção kuba-produto)
   Galeria com miniaturas, variantes (preço / parcelas / id / status / nota),
   combo "comprados juntos" (produto + extras no mesmo form nativo do Ecomus),
   frete grátis ([falta]) e "Avise-me" quando esgotado. Idempotente.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__kbPdpLoaded) { window.__kbPdpInit && window.__kbPdpInit(); return; }
  window.__kbPdpLoaded = true;

  function brl(cents, short) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var out = 'R$ ' + parts[0] + ',' + parts[1];
    if (short && parts[1] === '00') out = 'R$ ' + parts[0];
    return out;
  }
  function tpl(s, map) {
    return String(s || '').replace(/\[(\w+)\]/g, function (m, k) { return (k in map) ? map[k] : m; });
  }

  function setupGallery(sec) {
    var g = sec.querySelector('[data-kb-gallery]');
    if (!g || g.__kb) return null;
    g.__kb = true;
    var track = g.querySelector('[data-kb-track]');
    var slides = track ? track.children.length : 0;
    var dots = g.querySelectorAll('[data-kb-dot]');
    var prev = g.querySelector('[data-kb-prev]'), next = g.querySelector('[data-kb-next]');
    var i = 0;
    function go(n) {
      if (!slides) return;
      i = Math.max(0, Math.min(slides - 1, n));
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides - 1;
      // miniatura ativa visível: rola só a faixa (horizontal ou vertical), nunca a página
      var d = dots[i], box = d && d.parentElement;
      if (box && (box.scrollWidth > box.clientWidth || box.scrollHeight > box.clientHeight)) {
        var br = box.getBoundingClientRect(), dr = d.getBoundingClientRect(), pad = 4, dx = 0, dy = 0;
        if (dr.top < br.top) dy = dr.top - br.top - pad; else if (dr.bottom > br.bottom) dy = dr.bottom - br.bottom + pad;
        if (dr.left < br.left) dx = dr.left - br.left - pad; else if (dr.right > br.right) dx = dr.right - br.right + pad;
        if (dx || dy) { try { box.scrollBy({ left: dx, top: dy, behavior: 'smooth' }); } catch (e) { box.scrollLeft += dx; box.scrollTop += dy; } }
      }
    }
    prev && prev.addEventListener('click', function () { go(i - 1); });
    next && next.addEventListener('click', function () { go(i + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.kbDot, 10)); }); });
    var x0 = null;
    g.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    g.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });
    go(0);
    pinStage(g);
    return { go: go };
  }

  // Desktop: a galeria gruda logo abaixo do cabeçalho mantendo o MESMO espaço que tem ao abrir a página,
  // então foto e cabeçalho andam juntos (a barra de anúncio sai de cena) e depois ficam parados.
  // Para caber inteira na janela, a foto encolhe (mantendo a proporção) quando a tela é baixa.
  function pinStage(g) {
    var BOTTOM = 16, MIN_FRAME_H = 280;
    var frame = g.querySelector('.kb-pdp__frame');
    var hdr = document.querySelector('.shopify-section-header-sticky') || document.querySelector('header.shopify-section-group-header-group');
    var gap = 0, lastTop = -1;
    function scrollY() { return window.scrollY || window.pageYOffset || 0; }
    // fim do cabeçalho quando grudado: o "top" dele (ex.: altura da barra de anúncio fixa) + a altura dele
    function hdrStuckHeight() {
      if (!hdr) return 0;
      var cs = getComputedStyle(hdr), p = cs.position;
      if (p !== 'sticky' && p !== 'fixed') return 0;
      return (parseFloat(cs.top) || 0) + hdr.getBoundingClientRect().height;
    }
    function applyTop() {
      if (window.innerWidth < 960) return;
      var top = Math.round((hdrStuckHeight() + gap) * 100) / 100; // sem arredondar para pixel inteiro: evita tranco de 1px
      if (top !== lastTop) { g.style.top = top + 'px'; lastTop = top; }
    }
    function measure() {
      if (frame) frame.style.maxWidth = '';
      if (window.innerWidth < 960) { g.style.top = ''; lastTop = -1; return; }
      // posições de fluxo (sem sticky) da galeria e do fim do cabeçalho
      var gp = g.style.position, hp = hdr ? hdr.style.position : '';
      g.style.position = 'static'; if (hdr) hdr.style.position = 'static';
      var y = scrollY();
      var stageTop = g.getBoundingClientRect().top + y;
      var hdrBottom = hdr ? hdr.getBoundingClientRect().bottom + y : 0;
      g.style.position = gp; if (hdr) hdr.style.position = hp;
      gap = Math.max(0, stageTop - hdrBottom);
      // cabe inteira abaixo do cabeçalho grudado?
      var room = window.innerHeight - (hdrStuckHeight() + gap) - BOTTOM;
      var over = g.offsetHeight - room;
      if (frame && over > 0) {
        var fh = frame.offsetHeight, fw = frame.offsetWidth;
        var nh = Math.max(MIN_FRAME_H, fh - over);
        if (fh > 0 && nh < fh) frame.style.maxWidth = Math.floor(fw * nh / fh) + 'px';
      }
      lastTop = -1; applyTop();
    }
    var t = null, raf = 0;
    function later() { clearTimeout(t); t = setTimeout(measure, 80); }
    measure();
    window.addEventListener('resize', later);
    window.addEventListener('load', measure);
    document.addEventListener('kb:ann-height', later); // barra de anúncio fixa mudou de altura (custom.js)
    // o cabeçalho pode mudar de altura ao rolar (versão compacta): acompanha
    window.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; applyTop(); });
    }, { passive: true });
  }

  // Depoimentos: um por vez, em loop (setas, bolinhas e arraste); altura fixa (a do maior depoimento)
  function setupReviews(sec) {
    var box = sec.querySelector('[data-kb-revs]');
    if (!box || box.__kb) return;
    box.__kb = true;
    var wrap = box.parentElement;
    var vp = box.querySelector('[data-kb-revs-viewport]');
    var track = box.querySelector('[data-kb-revs-track]');
    var n = track ? track.children.length : 0, i = 0;
    var prev = wrap.querySelector('[data-kb-revs-prev]'), next = wrap.querySelector('[data-kb-revs-next]');
    var dots = wrap.querySelectorAll('[data-kb-revs-dots] button');
    // altura fixa = a do maior depoimento, para a caixa não mudar de tamanho ao trocar
    function fit() { if (!vp) return; var h = 0; for (var c = 0; c < n; c++) h = Math.max(h, track.children[c].offsetHeight); vp.style.height = h + 'px'; }
    function go(k) {
      if (!n) return;
      i = ((k % n) + n) % n;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      for (var c = 0; c < n; c++) track.children[c].setAttribute('aria-hidden', c === i ? 'false' : 'true');
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
      fit();
    }
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });
    var x0 = null;
    box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });
    window.addEventListener('resize', fit);
    window.addEventListener('load', fit);
    go(0);
  }

  function setup(sec) {
    if (sec.__kb) return;
    sec.__kb = true;
    var gal = setupGallery(sec);
    setupReviews(sec);

    var form = sec.querySelector('form.kb-form');
    var radios = sec.querySelectorAll('[data-kb-variant]');
    var now = sec.querySelector('[data-kb-price-now]');
    var was = sec.querySelector('[data-kb-price-was]');
    var inst = sec.querySelector('[data-kb-installments]');
    var idInput = sec.querySelector('[data-kb-variant-id]');
    var buy = sec.querySelector('[data-kb-buy]');
    var buyLabel = sec.querySelector('[data-kb-buy-label]');
    var vName = sec.querySelector('[data-kb-variant-name]');
    var vNote = sec.querySelector('[data-kb-variant-note]');
    var status = sec.querySelector('[data-kb-status]');
    var notify = sec.querySelector('[data-kb-notify]');
    var notifyProduct = sec.querySelector('[data-kb-notify-product]');
    var shipNote = sec.querySelector('[data-kb-ship-note]');

    var bundle = sec.querySelector('[data-kb-bundle]');
    var locked = bundle ? bundle.querySelector('[data-kb-bundle-locked]') : null;
    var mainPriceEl = bundle ? bundle.querySelector('[data-kb-bundle-main-price]') : null;
    var rows = bundle ? bundle.querySelectorAll('[data-kb-bundle-item]') : [];
    var checks = bundle ? bundle.querySelectorAll('[data-kb-check]') : [];
    var bCta = bundle ? bundle.querySelector('[data-kb-bundle-cta]') : null;
    var bEmpty = bundle ? bundle.querySelector('[data-kb-bundle-empty]') : null;
    var bCount = bundle ? bundle.querySelector('[data-kb-bundle-count]') : null;
    // modo "botão principal adiciona tudo": o CTA principal leva os itens marcados e vira o texto do combo
    var buyBundle = !!(buy && buy.hasAttribute('data-kb-buy-bundle') && bundle);
    var buyLabelBase = buyLabel ? buyLabel.textContent : '';

    function current() {
      var r = null;
      radios.forEach(function (x) { if (x.checked) r = x; });
      if (r) {
        return { id: r.value, title: r.dataset.title || '', price: r.dataset.price, cents: parseInt(r.dataset.cents, 10) || 0,
          compare: r.dataset.compare || '', installment: r.dataset.installment || '', available: r.dataset.available === 'true',
          status: r.dataset.status || 'stock', note: r.dataset.note || '', media: r.dataset.media };
      }
      // produto sem variantes
      return { id: idInput ? idInput.value : '', title: '', price: now ? now.textContent : '', cents: locked ? (parseInt(locked.dataset.price, 10) || 0) : 0,
        available: !(buy && buy.disabled), status: 'stock', note: '' };
    }

    function extras() {
      var out = [];
      checks.forEach(function (c) { if (c.checked && !c.disabled) out.push({ id: c.value, price: parseInt(c.closest('[data-kb-bundle-item]').dataset.price, 10) || 0 }); });
      return out;
    }

    function setHidden(includeExtras) {
      rows.forEach(function (row) {
        var c = row.querySelector('[data-kb-check]');
        var on = includeExtras && c && c.checked && !c.disabled;
        row.querySelectorAll('input[type="hidden"]').forEach(function (h) { h.disabled = !on; });
      });
    }

    function paint() {
      var v = current();
      var ex = extras();
      var total = v.cents + ex.reduce(function (a, e) { return a + e.price; }, 0);

      if (radios.length) {
        if (now) now.textContent = v.price;
        if (was) { if (v.compare) { was.textContent = v.compare; was.hidden = false; } else { was.hidden = true; } }
        if (inst) inst.textContent = v.installment;
        if (idInput) idInput.value = v.id;
        if (vName) vName.textContent = v.title;
        if (vNote) { vNote.textContent = v.note; vNote.hidden = !v.note; }
        if (buy) { buy.disabled = !v.available; buy.hidden = !v.available; }
        if (buyLabel && buyLabel.dataset.tpl) buyLabel.textContent = tpl(buyLabel.dataset.tpl, { preco: v.price, titulo: '' }).replace(' · ', ' · ');
        if (status) {
          var txt = status.dataset[v.status] || '';
          status.textContent = txt;
          status.hidden = !txt;
          status.className = 'kb-pdp__avail kb-pdp__avail--' + v.status;
        }
        if (notify) notify.hidden = v.available;
        if (notifyProduct && v.title) {
          notifyProduct.value = notifyProduct.value.replace(/\([^)]*\)/, '(' + v.title + ')').replace(/variant=\d+/, 'variant=' + v.id);
        }
        if (locked) locked.dataset.price = String(v.cents);
        if (mainPriceEl) mainPriceEl.textContent = v.price;
        if (gal && v.media !== '' && v.media !== undefined) gal.go(parseInt(v.media, 10) || 0);
      }

      // combo
      rows.forEach(function (row) {
        var c = row.querySelector('[data-kb-check]');
        row.classList.toggle('is-off', !(c && c.checked && !c.disabled));
      });
      var n = ex.length + 1;
      if (bCount) bCount.textContent = n + (n === 1 ? ' item' : ' itens');
      if (bCta) {
        bCta.hidden = ex.length === 0 || !v.available;
        bCta.textContent = tpl(bCta.dataset.tpl || 'Adicionar [n] itens · [total]', { n: n, total: brl(total, true) });
      }
      if (bEmpty) bEmpty.hidden = ex.length > 0;
      if (buyBundle && buyLabel) {
        if (ex.length && v.available) buyLabel.textContent = tpl(buy.dataset.tplBundle || 'Adicionar [n] itens · [total]', { n: n, total: brl(total, true) });
        else if (!radios.length) buyLabel.textContent = buyLabelBase; // com variantes, o texto já foi refeito acima
      }

      // frete grátis
      if (shipNote) {
        var th = parseInt(shipNote.dataset.threshold, 10) || 0;
        if (th > 0 && shipNote.dataset.tpl) {
          var falta = th - total;
          shipNote.textContent = falta > 0 ? tpl(shipNote.dataset.tpl, { falta: brl(falta) }) : (shipNote.dataset.done || tpl(shipNote.dataset.tpl, { falta: brl(0) }));
        }
      }
    }

    radios.forEach(function (r) { r.addEventListener('change', paint); });
    checks.forEach(function (c) { c.addEventListener('change', paint); });

    // CTA principal: só o produto (ou produto + extras no modo buyBundle). CTA do combo: produto + extras marcados.
    if (buy) buy.addEventListener('click', function () { setHidden(buyBundle); });
    if (bCta) bCta.addEventListener('click', function () { setHidden(true); });
    if (form) form.addEventListener('submit', function (e) {
      var sub = e.submitter;
      setHidden(buyBundle || !!(sub && sub.hasAttribute('data-kb-bundle-cta')));
    }, true);

    var nf = notify ? notify.querySelector('form') : null;
    if (nf) nf.addEventListener('submit', function () {
      var b = nf.querySelector('[type="submit"]');
      if (b) { b.disabled = true; b.textContent = b.dataset.sending || 'Enviando…'; }
    });

    paint();
  }

  function init() { document.querySelectorAll('[data-kb-pdp]').forEach(setup); }
  window.__kbPdpInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
})();
